import { getEnvironment, isEmpty } from "base/utils";
import { ENVIRONMENT_TYPES } from "base/constants";
import { useAccountStore, useUserStore } from "base/stores";

import { AdminService } from "./admin.service.js";

export const singleSignOn = async (url) => {
  url = new URL(`https://${url}`);

  let domain = url.hostname;
  let urlString = url.toString();
  let path = url.pathname || "";
  let search = url.search || "";

  try {
    let [apiRequest] = AdminService.getAccountDetails(domain);

    let data = await apiRequest();

    if (data.UserDetails?.status === "error") {
      const [sigininSSOCall] = AdminService.ssoSandbox(data);

      let response = await sigininSSOCall();

      return Promise.resolve(
        `${response.RedirectURL}${
          path ? `&redirect_path=${path + search}` : ""
        }`
      );
    }

    return Promise.resolve(urlString);
  } catch (error) {
    return Promise.resolve(`${url.origin}/login?e=KISSFLOW_ERROR_00015`);
  }
};

async function doSSOForSandboxAccount(type, path) {
  let sandboxEnv = getEnvironment((env) => env.Type === type);

  if (sandboxEnv) {
    let domain = sandboxEnv.CustomDomain || sandboxEnv.Endpoint;
    let redirectUrl = await singleSignOn(`${domain}${path}`);

    return new URL(redirectUrl);
  }

  return "";
}

// Note: This method is used account, platform and application so keep it in account
//       and this method is more related to the singleSignOn method!
export async function openAppBuilder(appId) {
  let currentEnv = useUserStore.getState().currentEnvironment;
  let path = `/appbuilder/${appId}`;

  if (currentEnv.Type !== ENVIRONMENT_TYPES.DEVELOPMENT) {
    let redirectSSOUrl = await doSSOForSandboxAccount(
      ENVIRONMENT_TYPES.DEVELOPMENT,
      path
    );

    if (redirectSSOUrl) {
      window.open(redirectSSOUrl.href, `${redirectSSOUrl.origin}${path}`);
    }
    return;
  }

  let url = `${window.origin}/appbuilder/${appId}`;

  window.open(url, url);
}

export async function openTestAccountApp(appId) {
  let currentEnv = useUserStore.getState().currentEnvironment;
  let path = `/view/application/${appId}`;

  if (currentEnv.Type !== ENVIRONMENT_TYPES.TEST) {
    let redirectSSOUrl = await doSSOForSandboxAccount(
      ENVIRONMENT_TYPES.TEST,
      `/view/application/${appId}`
    );

    if (redirectSSOUrl) {
      window.open(redirectSSOUrl.href, redirectSSOUrl.origin);
    }
    return;
  }

  let url = `${window.origin}${path}`;

  window.open(url, window.origin);
}

/**
 * Note : This logic should move to server in future.
 */
export function authenticateSandbox(isLoginPath = false) {
  const accountId = useAccountStore.getState()._id;
  const parentAccount = useAccountStore.getState().ParentAccount;
  const isSandboxAccount = !isEmpty(parentAccount);

  if (isSandboxAccount) {
    const parentEndpoint = parentAccount.CustomDomain || parentAccount.Endpoint;
    const { pathname, search = "" } = window.location;

    window.location.replace(
      `https://${parentEndpoint}/view/sandboxAuth/${accountId}?redirect_path=${
        isLoginPath ? "/view/home" : pathname + search
      }`
    );
  }
}
